(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconic-newsletter-popup"]) return;
  try {
    
  if (customElements.get('iconic-newsletter-popup')) {
    return;
  }

  class IconicnewsletterPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initIconicnewsletterPopup();
    }

    initIconicnewsletterPopup() {
      const newsletterPopup = document.querySelector("[id^='iconicNewsletterPopup-']");
      const newsletterModal = document.querySelector("[id^='iconicNewsModal-']");
      const testMode = newsletterPopup.getAttribute('data-popup-test');
      const delay = newsletterPopup.getAttribute('data-popup-delay') * 1000;
      const frequency = newsletterPopup.getAttribute('data-popup-frequency');
      const cookieName = newsletterPopup.getAttribute('data-popup-name');
      const newsletterForm = this.querySelectorAll('.iconic-needs-validation');

      Array.from(newsletterForm).forEach(function (newsletterForm) {
        newsletterForm.addEventListener(
          'submit',
          function (event) {
            if (!newsletterForm.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              setCookie(cookieName, true, frequency);
              newsletterModal.hide();
            }
            newsletterForm.classList.add('was-validated');
          },
          false
        );
      });

      if (testMode) {
        setTimeout(function () {
          newsletterModal.show();
        }, delay);
      } else {
        setTimeout(function () {
          const days = getCookie(cookieName);
          if (!days) {
            newsletterModal.show();
          }
        }, delay);
      }

      const closeButton = this.querySelector('.iconic-btn-close');
      closeButton.addEventListener('click', () => {
        setCookie(cookieName, true, frequency);
        newsletterModal.hide();
      });
    }
  }
  customElements.define('iconic-newsletter-popup', IconicnewsletterPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
